import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import TrainsList from '../../../components/operationals/trains/general/list';
import { faHome } from '@fortawesome/pro-light-svg-icons';

interface ITrainsListPageProps {
}

const TrainsListPage: React.FC<ITrainsListPageProps> = (props: ITrainsListPageProps) => {
    const {topbar} = useStore();

    useEffect(() => {
        topbar.show("Trains", [
            {key: "home", icon: faHome, href: "/"},
            {key: "operationals", text: 'Operationals'},
            {key: "trains", text: 'Trains'}
        ])
    }, []);

    return <Stack>
        <TrainsList />
    </Stack>;
};

export default TrainsListPage;
